import LzDialog from '@/components/common/LzDialog';
import styles from './index.module.scss';
import React, { useEffect, useState } from 'react';
import Tips from '@/components/UI/Tips';
import { Button, Loading, Radio } from '@alifd/next';
import { CanvasService } from '@/service';
import LzMsg from '@/components/common/LzMsg';

function BatchSecondaryMarket(props) {
  const {batchSecondaryVisible, setBatchSecondaryVisible, record} = props;
  const [isLoading,setIsLoading] = useState(false);
  const [crowdInfo,setCrowdInfo] = useState([]);
  // 人群选择
  const [crowdChoose, setCrowdChoose] = useState(1);
  const createSecondaryMarketCrowd = () => {
    setIsLoading(true);
    CanvasService.batchCreateSecondaryMarketingCrowd(
      {
        crowdRequests:crowdInfo,
        crowdSelection:crowdChoose
      }
      )
      .then((res) => {
        if (res.data) {
          setIsLoading(false);
          LzMsg.success('操作完成！生成详情请于各个任务的二次营销页面中查看~');
          setBatchSecondaryVisible(false);
        } else {
          setIsLoading(false);
          LzMsg.error('人群创建失败，请重新创建或联系管理员');
        }
      })
      .catch((e) => {
        setIsLoading(false);
        console.log(e);
      });
  }
  useEffect(()=>{
    let newRecord = []
    record.forEach((item,index) => {
      CanvasService.getSmsResultids({
        taskInstId: item.taskInstId,
        taskType: item.taskType || 4,
      })
        .then((res) => {
          // 临时注掉
          if(res.data){
            newRecord.push({
              crowdDescription: item.campaignRemark,
              crowdName: item.crowdName,
              resultStrategyInstId: res.data.resultStrategyInstId,
              sendTime: item.sendTime,
              strategyInstId:res.data.strategyInstId,
              taskId:res.data.taskId,
              taskInstId: item.taskInstId,
            })
            }
          })
          .catch((e) => {
            console.log(e);
          });
        // console.log()
    })
    setCrowdInfo(newRecord);

  },[])
  return (
    <LzDialog
      visible={batchSecondaryVisible}
      shouldUpdatePosition
      title="批量生成二次营销人群"
      onClose={() => {
        setBatchSecondaryVisible(false);
      }}
      style={{ width: '1060px'}}
      footer={false}
      isFullScreen
    >
      <Loading visible={isLoading} fullScreen/>
     <div className={styles['big-box']}>
        <div>
          <Tips content={
            <div>
              <div>提示:</div>
              <div>1.已发送成功的活动，可以提取其成功触达的人群，在我的人群库中生成新人群并进行营销。</div>
              <div>2.人群生成需要时间，请耐心等待,人群生成中可以关闭窗口。</div>
              <div>3.保存成功的人群会生成在我的人群库-人群包列表中，所生成的人群包类型为二次营销。</div>
              <div>4.二次发送人群筛选会因为其他营销行为造成的用户成交而导致筛选结果不够精准，因此建议如需生成二次发送人群的话，可在营销后3-7天进行，数据相对较为精准，</div>
              <div>5.批量生成二次营销，人群名称和描述均默认为 节点名称+二次营销+六位随机数。</div>
              <div>6.批量生成二次营销,只能统一生成一种类型的人群，如只能选择原营销人群包或本次营销成功人群等等。</div>
            </div>
          }/>
        </div>
        <div className={styles['params-box']}>
          <div><span className={styles.ff3333}>*</span>二次营销人群选择:</div>
          <div className={styles['params-select-box']}>
            <Radio.Group
              direction="hoz"
              value={crowdChoose}
              style={{ display: 'flex' }}
              onChange={(value) => {
                setCrowdChoose(+value);
              }}
            >
              <Radio value={1} style={{ flex: '1' }}>
                <span style={{ paddingLeft: '2px' }}>原营销人群包</span>
              </Radio>
              <Radio value={2} style={{ flex: '1' }}>
                <span style={{ paddingLeft: '2px' }}>本次营销成功人群</span>
              </Radio>
              <Radio value={3} style={{ flex: '1' }}>
                <span style={{ paddingLeft: '2px' }}>本次未营销人群</span>
              </Radio>
              <Radio value={4} style={{ flex: '1' }}>
                <span style={{ paddingLeft: '2px' }}>下单用户</span>
              </Radio>
              <Radio value={5} style={{ flex: '1' }}>
                <span style={{ paddingLeft: '2px' }}>未下单用户</span>
              </Radio>
              <Radio value={6} style={{ flex: '1' }}>
                <span style={{ paddingLeft: '2px' }}>付款用户</span>
              </Radio>
            </Radio.Group>
          </div>
        </div>
        <div style={{ flex: 1, textAlign: 'right',marginTop:'25px' }}>
          <Button
            type="primary"
            style={{ width: '88px', height: '30px', padding: 0 }}
            onClick={() => {
              createSecondaryMarketCrowd();
            }}
          >
            确认生成
          </Button>
        </div>
     </div>
  </LzDialog>
  );
}

export default BatchSecondaryMarket;
